// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"523":"05adee3d","787":"2c6415ae"}[chunkId] + ".chunk.js";
};